import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";
import {
  UserCard as UserCardType,
  UserData,
} from "../../../types/seatApproval.ts";
import star from "../../../assets/images/star.svg";
import { Button } from "../Button"; // Adjust path as needed
import CloseIcon from "@mui/icons-material/Close";
import defaultProfileIcon from "../../../assets/images/default-profile.svg";
import { Avatar } from "@mui/material";
import { ApprovalStatus } from "../../../constants/textConstants.ts";
import RoommatePreferencePopup from "../../../components/HdbDotPopover/index.tsx";
import shuffle from "../../../assets/images/shuffle-img.svg";
import uniarrow from "../../../assets/images/arrow-1.svg";
import swaparrow from "../../../assets/images/swap-arrow.svg";
import profile from "../../../assets/images/profile-bg.webp";
import UserPreferencesDropdown from "../UserPreferenceDropDown/index.tsx";
import SessionOverlay from "../../../components/SeatApprovalFlow/SessionOverlay/index.tsx";
import { ApiService } from "../../../services/mockService.ts";
import { mapApiDataToUserCards } from "../../../utils/dataMapper.ts";
interface UserCardProps {
  user: UserCardType;
  getInitials: (name: string) => string;
  handleSeekerClick?: (user: UserData) => void;
  setSelectedSession?: (session: any) => void;
  sessionId: number;
  handleBless: (user: UserData, sessionId: number, tag: string) => void;
  handleBlessed: (
    seekerId: number,
    targetProgramId: number | string,
    swapType: string,
    swapRequestId?: number,
    selectedSwapSeeker?: UserData | null,
  ) => void;
  isFlipped?: boolean;
  onFlip?: () => void;
  onCloseFlip?: () => void;
  programsList?: any[];
  allocatedProgramId?: number | string | null;
  highlightAllocated?: boolean;
  handleShowAllMatches?: (name: string) => void;
  setShowOverlay?: (show: boolean) => void;
  setIsCardClicked?: (isClicked: boolean) => void;
  fetchApprovedUsersForSession?: (session: {
    kpiCategory: string;
    kpiFilter: string;
  }) => void;
  selectedSwapSeeker?: UserData | null;
  setExcludedUserId?: (id: number | null) => void;
  setSelectedSwapSeeker?: (seeker: UserData | null) => void;
  setCustomTitle?: (title: string) => void;
  sessions: any[];
  selectedFilter: { [key: string]: any };
  isOverlay?: boolean;
}
const UserCard: React.FC<UserCardProps> = ({
  user,
  getInitials,
  sessionId,
  handleBless,
  setSelectedSession,
  isFlipped = false,
  onFlip,
  onCloseFlip,
  handleSeekerClick,
  programsList = [],
  allocatedProgramId,
  highlightAllocated,
  handleShowAllMatches,
  handleBlessed,
  setShowOverlay,
  fetchApprovedUsersForSession,
  setIsCardClicked,
  selectedSwapSeeker,
  setExcludedUserId,
  setSelectedSwapSeeker,
  setCustomTitle,
  sessions,
  selectedFilter,
  isOverlay = true,
}) => {
  console.log(
    "usercard session:",
    user?.swapRequests,
    user?.programPreferences,
    user,
    isFlipped,
  );
  console.log("selectedFilterInUSerCard", selectedFilter);
  const [selectedPref, setSelectedPref] = useState(null);
  const [programList, setProgramList] = useState<any[]>([]);
  const [showProgramList, setShowProgramList] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState(null);

  const [isSessionOverlayOpen, setIsSessionOverlayOpen] = useState(false);
  const [sessionOverlayUsers, setSessionOverlayUsers] = useState<UserData[]>(
    [],
  );

  const handleOpenSessionOverlay = async (
    userId: number,
    selectedSession?: unknown,
  ) => {
    // Use fetchApprovedUsersForSession to get all users with kpiCategory and kpiFilter as "all"
    console.log(selectedSession, "selectedSession");
    setShowOverlay(true); // Open the overlay
    setCustomTitle && setCustomTitle(`Select seeker to swap from ${selectedSession?.name}`);
    setIsCardClicked(true); // Set card clicked state to true
    setExcludedUserId(userId);
    console.log("loaderr3");
    setSelectedSession &&
      setSelectedSession({
        kpiCategory: "allocated",
        kpiFilter: `program_${selectedSession.value || selectedSession.id}`,
        SwapRequests: selectedFilter?.wantsSwap || "",
      });
    console.log("loaderr4");
    fetchApprovedUsersForSession({
      kpiCategory: "allocated",
      kpiFilter: `program_${selectedSession.value || selectedSession.id}`,
      SwapRequests: selectedFilter?.wantsSwap || "",
    });
  };

  const formatPreferences = (preferences: Array<{ name: string }>) => {
    return preferences.map((pref) => pref.name).join(", ");
  };
  console.log(user, "user in UserCard");
  const handlePrefClick = (pref: unknown) => {
    if (pref === "Mahatria's choice") {
      const programList = programsList.map((program) => ({
        id: program.id,
        name: program.name,
      }));
      console.log("Program List:", programList);
      setProgramList(programList);
      setShowProgramList(true);
      setSelectedProgram(null); // Reset selected program
    } else {
      console.log("Preference clicked:", pref);
      setShowProgramList(false);
      setSelectedPref(pref);
    }
    onFlip && onFlip();
  };

  const handleProgramSelect = (program: any) => {
    setSelectedProgram(program);
    setSelectedPref(program); // Update selectedPref with the chosen program
  };

  const handleBlessAction = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!selectedPref) return;

    if (user.approvalStatus !== ApprovalStatus?.PENDING) {
      console.log("Selected Preferencessss:", selectedPref);
      // Call handleBlessed for approved/hold/rejected users
      handleBlessed(
        selectedSwapSeeker ? user?.registrationId : user.id,
        selectedPref.value,
        selectedSwapSeeker ? "swap" : "move",
        user?.swapRequestId || undefined,
        selectedSwapSeeker,
      );
    } else {
      console.log("Selected Preferencess:", selectedPref);
      // Call handleBless for other cases
      const sessionId = selectedPref.id || selectedPref.value; // Use id if available, else value
      handleBless(user, sessionId, selectedPref.name);
    }
    // Reset states
    setSelectedPref(null);
    setSelectedProgram(null);
    setShowProgramList(false);
    onCloseFlip?.();
  };

  const handleClose = (e: any) => {
    e.stopPropagation();
    setSelectedPref(null);
    setSelectedSwapSeeker(null);
    setSelectedProgram(null);
    setShowProgramList(false);
    onCloseFlip && onCloseFlip();
  };

  console.log("Selected Preference:", selectedPref);
  console.log("Selected Program:", selectedProgram);
  const [showRoommatePopup, setShowRoommatePopup] = useState(false);
  const popupLeaveTimeout = React.useRef<NodeJS.Timeout | null>(null);

  return (
    <div
      className={`${styles.userCard} ${isFlipped ? styles.flipped : ""}`}
      onClick={!isFlipped ? handleSeekerClick : undefined}
      style={!isFlipped ? { cursor: "pointer" } : {}}
    >
      {!isFlipped ? (
        <>
          <div className={styles.userCardHeader}>
            <div className={styles.ratingWrapper}>
              <span className={styles.userCardDate}>{user.lastActiveDate}</span>
              {user?.rating && (
                <span className={styles.verticalDivider}>|</span>
              )}
              {user?.rating && (
                <span className={styles.starIcon}>
                  <img src={star} alt="star" width={13} height={13} />
                </span>
              )}
              <span className={styles.ratingText}>{user.rating}</span>
            </div>
          </div>
          <div className={styles.userCardContent}>
            <div className={styles.userAvatar}>
              <Avatar
                alt="Remy Sharp"
                src={user.profileImage || defaultProfileIcon}
                sx={{
                  width: 100,
                  height: 100,
                  border: "1px solid #fffff",
                }}
                data-testid="user-avatar"
              />
              {/* <img

                src={user.profileImage || defaultProfileIcon}
                alt={user.fullName}
                className={styles.avatarImg}
              /> */}
              <div className={styles.hdbBadgeWrapper}>
                {user?.preferredRoomMate && (
                  <div
                    className={styles.hdbDotPopoverWrapper}
                    onMouseEnter={() => {
                      if (popupLeaveTimeout.current)
                        clearTimeout(popupLeaveTimeout.current);
                      setShowRoommatePopup(true);
                    }}
                    onMouseLeave={() => {
                      popupLeaveTimeout.current = setTimeout(
                        () => setShowRoommatePopup(false),
                        100,
                      );
                    }}
                  >
                    <div className={styles.hdbDot}></div>
                    {showRoommatePopup && (
                      <div
                        onMouseEnter={() => {
                          if (popupLeaveTimeout.current)
                            clearTimeout(popupLeaveTimeout.current);
                          setShowRoommatePopup(true);
                        }}
                        onMouseLeave={() => {
                          popupLeaveTimeout.current = setTimeout(
                            () => setShowRoommatePopup(false),
                            100,
                          );
                        }}
                      >
                        <RoommatePreferencePopup
                          //  className={isLastCard ? `${styles.popup} ${styles.bottom}` : styles.popup}
                          roommateName={user.preferredRoomMate}
                          onShowMatches={() =>
                            handleShowAllMatches(user.preferredRoomMate)
                          }
                        />
                      </div>
                    )}
                  </div>
                )}
                <div className={styles.hdbBadge}>
                  {user.completedHDBs.toString().padStart(2, "0")} HDBs
                </div>
              </div>
            </div>
            <div className={styles.userInfo}>
              <h3 className={styles.userName}>{user.fullName}</h3>
              <div className={styles.userDetails}>
                <span className={styles.usersubdetails}>
                  {user.gender.charAt(0).toUpperCase()}
                </span>
                <span className={styles.divider}>|</span>
                <span className={styles.usersubdetails}>{user.age} yrs</span>
                {/* <span className={styles.divider}>|</span>
                <span className={styles.usersubdetails}>
                  {user.totalPrograms.toString().padStart(2, "0")} Programs
                </span> */}
                {user.city && <span className={styles.divider}>|</span>}
                {user.city && (
                  <span className={styles.usersubdetails}>{user.city}</span>
                )}
              </div>
              <div className={styles.horizontalDivider} />
              <div className={styles.userPreferences}>
                {user?.shiftRequests && user?.shiftRequests.length > 0 ? (
                  <div className={styles.shiftRequestWrapper}>
                    <div className={styles.shiftRequestDiv}>
                      <div className={styles.allocatedProgramDiv}>
                        <span className={styles.allocatedProgramName}>
                          {user?.allocatedProgram?.name} blessed
                        </span>
                      </div>
                      <span className={styles.shiftRequestText}>
                        can shift to{""}
                      </span>
                      {user?.shiftRequests.map((req: any, idx: number) => (
                        <span
                          className={styles.shiftRequestText}
                          key={idx}
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent parent click
                          }}
                        >
                          {req.name}
                          {idx < user?.shiftRequests.length - 1 && ", "}
                        </span>
                      ))}
                    </div>
                    {isOverlay && (
                      <UserPreferencesDropdown
                        preferences={(sessions ?? []).map((pref) => ({
                          name: pref.name,
                          value: pref.id || pref.name, // Use pref.id if available, else name
                        }))}
                        highlightPreference={user?.allocatedProgram?.name}
                        onSelect={(pref) => {
                          setSelectedPref(pref);
                          // This will trigger the same flow as clicking a preference chip
                          handlePrefClick(pref);
                        }}
                        onFlip={onFlip}
                        user={user}
                        swapRequests={user.swapRequests}
                        isswapRequest={true}
                      />
                    )}
                  </div>
                ) : user?.swapRequests && user?.swapRequests.length > 0 ? (
                  <>
                    <div className={styles.SwapRequestWrapper}>
                      <div className={styles.SwapRequestDiv}>
                        <span
                          className={styles.swapRequestText}
                          // onClick={(e) => {
                          // e.stopPropagation(); // Prevent parent click
                          // }}
                        >
                          swap {user?.allocatedProgram?.name}
                        </span>
                      </div>
                      <div>
                        <img src={shuffle} alt="shuffle" />
                      </div>

                      <div className={styles.requestedPrefWrapper}>
                        {user.swapRequests && user.swapRequests.length > 0 ? (
                          <>
                            {user.swapRequests.map((req: any, idx: number) => (
                              <span
                                className={styles.swapRequestText}
                                key={idx}
                              >
                                {req.name}
                                {idx < user.swapRequests.length - 1 && ", "}
                              </span>
                            ))}
                          </>
                        ) : (
                          <span className={styles.swapRequestText}>
                            Any program
                          </span>
                        )}
                      </div>
                    </div>
                    {isOverlay && (
                      <UserPreferencesDropdown
                        preferences={(sessions ?? []).map((pref) => ({
                          name: pref.name,
                          value: pref.id || pref.name, // Use pref.id if available, else name
                        }))}
                        highlightPreference={user?.allocatedProgram?.name}
                        onSelect={(pref) => {
                          setSelectedPref(pref);
                          // This will trigger the same flow as clicking a preference chip
                          handlePrefClick(pref);
                        }}
                        onFlip={onFlip}
                        user={user}
                        swapRequests={user.swapRequests}
                        isswapRequest={true}
                      />
                    )}
                  </>
                ) : (
                  <>
                    {user.approvalStatus === ApprovalStatus?.PENDING ? (
                      <>
                        {user?.programPreferences.length < 1 ? (
                          <div className={styles.mahatriaChipWrapper}>
                            <span
                            // <span
                            //   className={styles.mahatriaChip}
                            //   onClick={(e) => {
                            //     e.stopPropagation(); // Prevent parent click
                            //     handlePrefClick("Mahatria's choice");
                            //   }}
                            >
                              {/* <span className={styles.mahatriaRed}>
                              Mahatria's{" "}
                            </span> */}
                              {/* <span className={styles.mahatriaBlue}>
                                {" "}
                                Any HDB/MSD
                              </span> */}
                            </span>
                            {isOverlay && (
                              <UserPreferencesDropdown
                                preferences={(sessions ?? []).map((pref) => ({
                                  name: pref.name,
                                  value: pref.id || pref.name, // Use pref.id if available, else name
                                }))}
                                onSelect={(pref) => {
                                  setSelectedPref(pref);
                                  // This will trigger the same flow as clicking a preference chip
                                  handlePrefClick(pref);
                                }}
                                highlightPreference={
                                  "mahatriaChoiceUnallocated"
                                }
                                onFlip={onFlip}
                                user={user}
                              />
                            )}
                          </div>
                        ) : (
                          <div className={styles.unallocatedPreferences}>
                            {user.programPreferences.map((pref, idx) => (
                              <span
                                key={idx}
                                className={`
                        ${styles.preferenceChip}
                        ${
                          highlightAllocated && allocatedProgramId === pref.id
                            ? styles.allocatedChip
                            : ""
                        }
                      `}
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevent parent click
                                  handlePrefClick(pref);
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                {pref.name}
                              </span>
                            ))}
                            {isOverlay && (
                              <UserPreferencesDropdown
                                preferences={user.programPreferences.map(
                                  (pref) => ({
                                    label: pref.name,
                                    value: pref.id || pref.name, // Use pref.id if available, else name
                                  }),
                                )}
                                highlightPreference={"preferencesUnallocated"}
                                onSelect={(pref) => {
                                  setSelectedPref(pref);
                                  handlePrefClick(pref);
                                }}
                              />
                            )}
                          </div>
                        )}
                      </>
                    ) : user?.approvalStatus === ApprovalStatus?.APPROVED ? (
                      <>
                        {user?.swapRequests && user?.swapRequests.length > 0 ? (
                          <></>
                        ) : (
                          <div className={styles.userPreferences}>
                            {user?.allocatedProgram && (
                              <div className={styles.allocatedProgramWrapper}>
                                <div className={styles.allocatedProgramDiv}>
                                  <span className={styles.allocatedProgramName}>
                                    {user?.allocatedProgram?.name} blessed
                                  </span>
                                </div>
                                {/* <span className={styles.divider}>|</span> */}
                                {user.programPreferences &&
                                user.programPreferences.length === 0 ? (
                                  <>
                                    {/* <span
                                      className={styles.mahatriaChipNoBg}
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent parent click
                                      }}
                                    >
                                      <span className={styles.mahatriaRed}>
                                        Mahatria's{" "}
                                      </span>
                                      <span className={styles.mahatriaBlue}>
                                        {" "}
                                        choice
                                      </span>
                                    </span> */}
                                    {isOverlay && (
                                      <UserPreferencesDropdown
                                        preferences={(sessions ?? []).map(
                                          (pref) => ({
                                            name: pref.name,
                                            value: pref.id || pref.name, // Use pref.id if available, else name
                                          }),
                                        )}
                                        onSelect={(pref) => {
                                          setSelectedPref(pref);
                                          // This will trigger the same flow as clicking a preference chip
                                          handlePrefClick(pref);
                                        }}
                                        highlightPreference={
                                          user.allocatedProgram?.name
                                        }
                                        mahatriachoiceType={
                                          "mahatriaChoiceBlessed"
                                        }
                                        onFlip={onFlip}
                                        user={user}
                                      />
                                    )}
                                  </>
                                ) : (
                                  user.programPreferences &&
                                  user.programPreferences.length > 0 && 
                                  isOverlay && (
                                    <UserPreferencesDropdown
                                      preferences={user.programPreferences.map(
                                        (pref) => ({
                                          name: pref.name,
                                          value: pref.id || pref.name, // Use pref.id if available, else name
                                        }),
                                      )}
                                      highlightPreference={
                                        user?.allocatedProgram?.name
                                      }
                                      onSelect={(pref) => {
                                        setSelectedPref(pref);
                                        // This will trigger the same flow as clicking a preference chip
                                        handlePrefClick(pref);
                                      }}
                                      onFlip={onFlip}
                                      user={user}
                                    />
                                  )
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        {user.approvalStatus === ApprovalStatus?.ON_HOLD ||
                        user.approvalStatus === ApprovalStatus?.REJECTED ? (
                          <div className={styles.userPreferences}>
                            <div className={styles.allocatedProgramWrapper}>
                              {user.approvalStatus ===
                                ApprovalStatus?.ON_HOLD ||
                              user.approvalStatus ===
                                ApprovalStatus?.REJECTED ? (
                                <div
                                  className={
                                    user.approvalStatus ===
                                    ApprovalStatus?.ON_HOLD
                                      ? styles.yetToDecideDiv
                                      : styles.holdDiv
                                  }
                                >
                                  <span
                                    className={
                                      user.approvalStatus ===
                                      ApprovalStatus?.ON_HOLD
                                        ? styles.holdText
                                        : styles.holdText
                                    }
                                  >
                                    {user.approvalStatus ===
                                    ApprovalStatus?.ON_HOLD
                                      ? "YTD"
                                      : "on hold"}
                                  </span>
                                </div>
                              ) : (
                                <span>[Hold]</span>
                              )}{" "}
                              {/* <span className={styles.divider}>|</span>' */}
                              {user.programPreferences &&
                              user.programPreferences.length === 0 ? (
                                <>
                                  <span
                                    className={styles.mahatriaChipNoBg}
                                    onClick={(e) => {
                                      e.stopPropagation(); // Prevent parent click
                                    }}
                                  >
                                    {isOverlay && (
                                      <UserPreferencesDropdown
                                        preferences={(sessions ?? []).map(
                                          (pref) => ({
                                            name: pref.name,
                                            value: pref.id || pref.name, // Use pref.id if available, else name
                                          }),
                                        )}
                                        onSelect={(pref) => {
                                          setSelectedPref(pref);
                                          handlePrefClick(pref);
                                        }}
                                        mahatriachoiceType="mahatriaChoiceHold"
                                        highlightPreference={
                                          user.approvalStatus ===
                                          ApprovalStatus?.ON_HOLD
                                            ? "yet-to-decide"
                                            : user.approvalStatus ===
                                                ApprovalStatus?.REJECTED
                                              ? "hold"
                                              : user?.allocatedProgram?.id ||
                                                user?.allocatedProgram?.name
                                        }
                                      />
                                    )}
                                  </span>
                                </>
                              ) : (
                                user.programPreferences &&
                                user.programPreferences.length > 0 &&
                                isOverlay && (
                                  <UserPreferencesDropdown
                                    preferences={user.programPreferences.map(
                                      (pref) => ({
                                        name: pref.name,
                                        value: pref.id || pref.name, // Use pref.id if available, else name
                                      }),
                                    )}
                                    highlightPreference={
                                      user.approvalStatus ===
                                      ApprovalStatus?.ON_HOLD
                                        ? "yet-to-decide"
                                        : user.approvalStatus ===
                                            ApprovalStatus?.REJECTED
                                          ? "hold"
                                          : user?.allocatedProgram?.id ||
                                            user?.allocatedProgram?.name
                                    }
                                    onSelect={(pref) => {
                                      setSelectedPref(pref);
                                      handlePrefClick(pref);
                                    }}
                                  />
                                )
                              )}
                            </div>
                            {/* )} */}
                          </div>
                        ) : (
                          <></>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className={styles.userCardHeader}>
            <button
              className={styles.closeIcon}
              onClick={(e) => {
                handleClose(e);
              }}
              type="button"
              aria-label="Close"
            >
              <CloseIcon fontSize="small" />
            </button>
          </div>
          {user.approvalStatus === ApprovalStatus?.APPROVED &&
          selectedPref?.name !== "Hold" &&
          selectedPref?.name !== "YTD" ? (
            <div
              className={`${styles.userCardContent} ${isFlipped ? styles.flipped : ""}`}
            >
              <div className={styles.hdbCard}>
                <Avatar
                  alt={user.fullName}
                  src={user.profileImage || defaultProfileIcon}
                  sx={{
                    width: 100,
                    height: 100,
                    border: "2px solid #fff",
                    boxShadow: "0 0 8px rgba(0,0,0,0.1)",
                  }}
                />
                <div className={styles.hdbLabel}>
                  {user?.allocatedProgram?.name}
                </div>
              </div>

              <div className={styles.swapAction}>
                <div className={styles.swapText}>
                  {selectedSwapSeeker ? (
                    // Show both users' movements when swap seeker is selected
                    <>
                      Moving {user.fullName} to{" "}
                      {selectedSwapSeeker?.allocatedProgram?.name} and{" "}
                      {selectedSwapSeeker.fullName} to{" "}
                      {user?.allocatedProgram?.name}
                      <div>
                        <img src={swaparrow} alt="arrow" />
                      </div>
                    </>
                  ) : (
                    // Show single user movement when no swap seeker selected
                    <>
                      moving {user.fullName} from {user?.allocatedProgram?.name}{" "}
                      to {selectedPref?.name}
                      <div>
                        <img src={uniarrow} alt="arrow" />
                      </div>
                    </>
                  )}
                </div>

                <div className={styles.blessButton}>
                  <Button
                    type="submit"
                    buttonClassName={`${styles.buttonContainer}`}
                    buttonTextClassName={styles.buttonText}
                    datatestid="add-program-save-button"
                    datatestidText="add-program-save"
                    onClick={(e) => {
                      handleBlessAction(e);
                    }}
                  >
                    <span className={styles.blessText}>bless</span>
                  </Button>
                </div>
              </div>

              {selectedSwapSeeker ? (
                <div className={styles.hdbCard}>
                  <Avatar
                    alt={selectedSwapSeeker.fullName}
                    src={selectedSwapSeeker.profileImage || defaultProfileIcon}
                    sx={{
                      width: 100,
                      height: 100,
                      border: "2px solid #fff",
                      boxShadow: "0 0 8px rgba(0,0,0,0.1)",
                    }}
                  />
                  <div className={styles.hdbLabel}>
                    {selectedSwapSeeker?.allocatedProgram?.name}
                  </div>
                </div>
              ) : (
                <div
                  className={styles.hdbCard}
                  onClick={() => {
                    console.log("Opening session overlay", user.id);
                    handleOpenSessionOverlay(user.id, selectedPref);
                  }}
                >
                  <div className={styles.avatarWithText}>
                    <span className={styles.selectSeekerText}>
                      select seeker to swap
                    </span>
                    <div
                      className={styles.roundImageBg}
                      style={{
                        backgroundImage: `url(${profile})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    ></div>
                  </div>
                  <div className={styles.hdbLabel}>{selectedPref?.name}</div>
                </div>
              )}
            </div>
          ) : (
            <div
              className={`${styles.userCardContent} ${isFlipped ? styles.flipped : ""}`}
            >
              <div className={styles.userAvatar}>
                <Avatar
                  alt="Remy Sharp"
                  src={user.profileImage || defaultProfileIcon}
                  sx={{
                    width: 100,
                    height: 100,
                    border: "1px solid #fffff",
                  }}
                  data-testid="user-avatar"
                />
              </div>
              <div className={styles.userInfo}>
                {showProgramList ? (
                  <h3 className={styles.redirectText}>
                    Choose a program to bless {user.fullName}
                    <br />
                    <div className={styles.userPreferences}>
                      {programList.map((program, idx) => (
                        <span
                          key={idx}
                          onClick={() => handleProgramSelect(program)}
                          className={`${styles.preferenceChip} ${
                            selectedProgram?.id === program.id
                              ? styles.selectedProgram
                              : ""
                          }`}
                          style={{
                            cursor: "pointer",
                            border:
                              selectedProgram?.id === program.id
                                ? "2px solid #007bff"
                                : "none",
                          }}
                        >
                          {program.name}
                        </span>
                      ))}
                    </div>
                  </h3>
                ) : (
                  <h3 className={styles.redirectText}>
                    You are blessing {user.fullName} by allocating
                    <br />
                    <span>{selectedPref?.name} seat</span>
                  </h3>
                )}
                <Button
                  buttonClassName={styles.actionButton}
                  buttonTextClassName={styles.actionButtonText}
                  onClick={(e) => {
                    handleBlessAction(e);
                  }}
                  disable={!selectedPref}
                >
                  {selectedPref?.name !== "Hold" && selectedPref?.name !== "YTD"
                    ? "bless"
                    : selectedPref?.name}
                </Button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default UserCard;
